import React from 'react'

const Navbar = () => {
    return (
        <nav className="text-center py-2 mb-2 bg-primary text-white font-monospace">
            <div className="container-fluid">
                <h2 className="text-center text-white">Daftar Surah</h2>
            </div>
        </nav>
    )
}

export default Navbar